export default "__VITE_ASSET__DDfq_Bam__"